import Accordion from "./Classes/Accordion";
import Swiper from "swiper";
import  {Navigation, Pagination, FreeMode} from "swiper/modules";
import Cv from "./Classes/Cv"
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import TableIconReplacer from "./Classes/TableIconReplacer";
import Anchor from "./Classes/Anchor.js";
import ImageContainerResizer from "./Classes/imageContainerResizer";
// import CountUpNumbers from './Classes/CountUpNumbers';
import keyFigure from './Classes/keyfigure.js';
import Scrollspy from "./Classes/Scrollspy";

let imageContainerResizerInstance = null;


window.addEventListener("page_event_load", () => {
  new Cv();
  new Anchor();
  new TableIconReplacer();
  new keyFigure();
  new Scrollspy();


  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });



  // const countUpInstance = new CountUpNumbers({
  //   numbersSelector: '.lc-keyfigure__number',
  //   classIn: 'is-in-viewport',
  //   classOut: 'is-not-in-viewport',
  //   langArray: ['de', 'en'],
  //   decimalArray: ['.', '.'],
  //   thousandSepArray: ['’', '’'],
  // });


  new Swiper('.swiper', {
    modules: [Navigation, Pagination, FreeMode],
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    freeMode: true,
    breakpoints: {
      0: {
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.5,
          momentumBounce: false,
          sticky: false,
        }
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1650: {
        slidesPerView: 3,
        spaceBetween: 24,
      }
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
});
  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});



window.addEventListener("page_event_load", () => {
    imageContainerResizerInstance = new ImageContainerResizer();
});

window.addEventListener("page_event_unloading", () => {
    if (imageContainerResizerInstance) {
        imageContainerResizerInstance.unsubscribe();
        imageContainerResizerInstance = null;
    }
});

window.addEventListener('note_event_load', evt => {
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});


window.addEventListener('note_unloaded', evt => {
  document.body.classList.remove("note-open");
});

export default {
  data() {
    return {
      sections: [],
      activeSection: null
    };
  },
  mounted() {
    // Initialize Scrollspy and update sections after the component is mounted
    this.scrollspy = new Scrollspy();
    this.scrollspy.init();  // Initialize and populate sections
    this.sections = this.scrollspy.sections;  // Bind sections to Vue data
  }
};
